export const translations = {
  it: {
    // Common
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    loading: 'Caricamento...',
    all: 'Tutti',
    yes: 'Sì',
    no: 'No',
    actions: 'Azioni',
    date: 'Data',
    time: 'Ora',
    note: 'Nota',
    reason: 'Motivo',
    back: 'Indietro',
    close: 'Chiudi',
    login: 'Accedi',
    logout: 'Esci',
    email: 'Email',
    password: 'Password',
    role: 'Ruolo',
    status: 'Stato',
    active: 'Attivo',
    inactive: 'Disattivo',
    // Nav
    dashboard: 'Dashboard',
    leads: 'Leads',
    campaigns: 'Campagne',
    calendar: 'Calendario',
    users: 'Utenti',
    import_leads: 'Importa Lead',
    // Theme
    light: 'Chiaro',
    dark: 'Scuro',
    // Login page
    login_title: 'CRM Outbound',
    login_subtitle: 'Sistema professionale per Call Center',
    login_button: 'Accedi',
    login_loading: 'Accesso...',
    login_success: 'Login effettuato con successo',
    login_demo: 'Demo Admin:',
    // Dashboard
    welcome: 'Benvenuto',
    total_leads: 'Lead Totali',
    new_leads: 'Lead Nuove',
    calls_today: 'Chiamate Oggi',
    deposits_today: 'Depositi Oggi',
    appointments_today: 'Appuntamenti Oggi',
    callbacks_pending: 'Da Richiamare',
    conversion_rate: 'Tasso Conversione',
    calls_week: 'Chiamate Settimana',
    calls_deposits: 'Chiamate e Depositi',
    weekly_performance: 'Performance Settimanale',
    // Leads page
    leads_title: 'Gestione Leads',
    leads_total: 'lead totali',
    search_placeholder: 'Cerca per nome, telefono, email...',
    all_campaigns: 'Tutte le campagne',
    all_status: 'Tutti gli stati',
    all_outcomes: 'Tutti gli esiti',
    outcome_none: 'Nessun esito',
    status_new: 'Nuova',
    status_contacted: 'Contattata',
    status_converted: 'Convertita',
    no_leads: 'Nessuna lead trovata',
    // Lead table columns
    col_created: 'Data creazione',
    col_name: 'Nome',
    col_email: 'Indirizzo e-mail',
    col_origin: 'Origine',
    col_module: 'Modulo',
    col_channel: 'Canale',
    col_stage: 'Fase',
    col_owner: 'Proprietario',
    col_labels: 'Etichette',
    col_phone: 'Telefono',
    col_phone2: 'Tel. secondario',
    col_whatsapp: 'WhatsApp',
    col_notes: 'Note',
    // Call modal
    call_in_progress: 'Chiamata in corso',
    call_outcome: 'Esito Chiamata',
    call_note: 'Nota Chiamata',
    call_save: 'Salva Chiamata',
    outcome_required: 'Seleziona un esito per la chiamata',
    note_required: 'Inserisci una nota obbligatoria',
    call_saved: 'Chiamata registrata con successo',
    number_copied: 'Numero copiato negli appunti',
    // Lead detail
    call: 'Chiama',
    country: 'Paese',
    language: 'Lingua',
    call_history: 'Storico Chiamate',
    no_calls: 'Nessuna chiamata registrata',
    operator: 'Operatore',
    duration: 'Durata',
    quick_actions: 'Azioni Rapide',
    create_appointment: 'Crea Appuntamento',
    schedule_callback: 'Programma Richiamo',
    fb_notes: 'Note Facebook',
    no_fb_notes: 'Nessuna nota disponibile',
    back_to_leads: 'Torna alle Leads',
    appointment_created: 'Appuntamento creato con successo',
    callback_created: 'Richiamo programmato con successo',
    // Campaigns
    campaigns_title: 'Gestione Campagne',
    campaigns_total: 'campagne totali',
    new_campaign: 'Nuova Campagna',
    campaign_name: 'Nome Campagna',
    campaign_created: 'Campagna creata con successo',
    campaign_deleted: 'Campagna eliminata con successo',
    confirm_delete_campaign: 'Sei sicuro di voler eliminare questa campagna?',
    // Users
    users_title: 'Gestione Utenti',
    users_total: 'utenti totali',
    new_user: 'Nuovo Utente',
    full_name: 'Nome Completo',
    campaigns_assigned: 'Campagne Assegnate',
    user_created: 'Utente creato con successo',
    user_deleted: 'Utente eliminato con successo',
    confirm_delete_user: 'Sei sicuro di voler eliminare questo utente?',
    admin: 'Admin',
    operator_role: 'Operatore',
    all_campaigns_short: 'Tutte',
    campaigns_count: 'campagne',
    // Calendar
    calendar_title: 'Calendario',
    calendar_subtitle: 'Appuntamenti e richiami programmati',
    today: 'Oggi',
    no_events: 'Nessun evento per questo giorno',
    // Validation
    fill_all_fields: 'Compila tutti i campi obbligatori',
    error_generic: 'Si è verificato un errore',
    col_outcome: 'Esito',
    // Import page
    import_title: 'Importazione Lead',
    import_subtitle: 'Carica file CSV o Excel e assegna a una campagna',
    import_step1: '1. Seleziona Campagna *',
    import_step2: '2. Carica File (CSV / XLSX) *',
    import_choose_campaign: 'Scegli English o Italian...',
    import_button: 'Importa',
    import_leads_count: 'lead',
    import_importing: 'Importazione in corso...',
    import_preview: 'Anteprima',
    import_preview_rows: 'righe totali - prime 5 mostrate',
    import_completed: 'Importazione completata',
    import_distribution: 'Distribuzione automatica agli operatori:',
    import_view_leads: 'Vai alle Lead',
    import_columns_info: 'Colonne riconosciute automaticamente',
    import_columns_desc: 'Nome, Cognome, Telefono, Email, Modulo, Origine, Canale, Fase, Etichette, Tel. secondario, WhatsApp, Note. La prima riga del file deve contenere i nomi delle colonne.',
    import_auto_assign_note: 'Le lead vengono distribuite automaticamente tra gli operatori assegnati alla campagna scelta.',
    // Users management
    users_full_name: 'Nome Completo *',
    users_email_required: 'Email *',
    users_password_required: 'Password *',
    users_role_required: 'Ruolo *',
    users_campaign_label: 'Campagna Assegnata (una sola)',
    users_create_new_title: 'Crea Nuovo Utente',
    users_create_new_desc: 'Inserisci i dettagli del nuovo utente',
    users_submit: 'Crea Utente',
    // Campaigns
    campaigns_active: 'Attiva',
    campaigns_inactive: 'Disattivata',
    campaigns_created_on: 'Creata il',
    campaigns_create_title: 'Crea Nuova Campagna',
    campaigns_create_desc: 'Inserisci il nome della nuova campagna',
    campaigns_submit: 'Crea Campagna',
    // Motivational
    motivational_title: '💎 Ogni chiamata è una nuova opportunità',
    motivational_sub: 'Trasforma i lead in successi',
    // Lead detail
    ld_back: 'Torna alle Leads',
    ld_number_to_call: 'Numero da chiamare',
    ld_copy_number: 'Copia Numero',
    ld_copied: 'Copiato!',
    ld_register_call: 'Registra Esito Chiamata',
    ld_outcome_label: 'Esito *',
    ld_note_label: 'Nota *',
    ld_outcome_placeholder: 'Seleziona esito...',
    ld_note_placeholder: 'Inserisci dettagli chiamata...',
    ld_save_call: 'Salva Chiamata',
    ld_saving: 'Salvataggio...',
    ld_outcome_hint: 'Se scegli "Appuntamento" o "Richiamo" si apre subito il form di pianificazione.',
    ld_appointments: 'Appuntamenti',
    ld_callbacks: 'Richiami',
    ld_new: 'Nuovo',
    ld_no_appointments: 'Nessun appuntamento',
    ld_no_callbacks: 'Nessun richiamo',
    ld_call_history: 'Storico Chiamate',
    ld_no_calls: 'Nessuna chiamata registrata',
    ld_new_appointment: 'Nuovo Appuntamento',
    ld_new_callback: 'Nuovo Richiamo',
    ld_reason: 'Motivo',
    ld_create_appointment: 'Crea Appuntamento',
    ld_schedule_callback: 'Programma Richiamo',
    ld_fb_notes: 'Note Facebook',
    ld_pick_date: 'Scegli data',
    ld_pick_time: 'Scegli ora',
    // Notifications
    notif_callback_title: '⏰ Richiamo tra 10 minuti',
    notif_open_lead: 'Apri Lead',
    // Export
    export: 'Esporta',
    export_csv: 'CSV',
    export_xlsx: 'Excel',
    export_pdf: 'PDF',
    export_started: 'Esportazione in corso...',
    export_completed: 'Esportazione completata',
    export_failed: 'Errore durante l\'esportazione',
    // Export dialog filters
    export_dialog_title: 'Esporta Lead',
    export_dialog_desc: 'Scegli il formato e i filtri prima di scaricare',
    export_format: 'Formato',
    export_filter_operator: 'Operatore',
    export_filter_campaign: 'Campagna',
    export_filter_all_operators: 'Tutti gli operatori',
    export_filter_all_campaigns: 'Tutte le campagne',
    export_download: 'Scarica',
    // Bulk reassign
    bulk_selected: 'lead selezionati',
    bulk_reassign_button: 'Riassegna',
    bulk_reassign_title: 'Riassegna lead selezionati',
    bulk_reassign_desc: 'Scegli l\'operatore a cui assegnare i lead selezionati.',
    bulk_reassign_operator_label: 'Nuovo operatore',
    bulk_reassign_operator_placeholder: 'Seleziona un operatore',
    bulk_reassign_confirm: 'Conferma riassegnazione',
    bulk_reassign_cancel: 'Annulla',
    bulk_reassign_success: 'Riassegnati $count lead a $name',
    bulk_reassign_error: 'Errore nella riassegnazione',
    bulk_reassign_pick_operator: 'Seleziona un operatore',
    bulk_clear: 'Deseleziona',
    // Users - edit campaigns
    users_edit_campaigns_title: 'Modifica campagne',
    users_edit_campaigns_desc: 'Seleziona una o più campagne. L\'operatore vedrà solo i lead delle campagne selezionate.',
    users_edit_campaigns_ok: 'Campagne aggiornate',
    users_edit_campaigns_min: 'Seleziona almeno una campagna',
    users_edit_saving: 'Salvataggio...',
    users_edit_save: 'Salva',
    users_all_campaigns: 'Tutte',
    // Calendar list view
    view_calendar: 'Calendario',
    view_list: 'Lista',
    list_appointments_title: 'Clienti con Appuntamento',
    list_callbacks_title: 'Clienti da Richiamare',
    list_all_title: 'Lista Clienti',
    list_subtitle: 'Elenco completo con nome, telefono e note',
    list_filter_all: 'Tutti',
    list_filter_appointments: 'Appuntamenti',
    list_filter_callbacks: 'Da richiamare',
    list_col_datetime: 'Data e ora',
    list_empty: 'Nessun cliente con questo esito.',
    open_lead: 'Apri Lead',
    // Security page
    sec_nav: 'Sicurezza',
    sec_title: 'Sicurezza',
    sec_subtitle: 'Whitelist IP: solo gli indirizzi qui elencati potranno accedere al sistema',
    sec_enforce_title: 'Restrizione IP',
    sec_enforce_desc: 'Attiva per bloccare l\'accesso a qualsiasi IP non presente nella lista. Massimo 10 IP.',
    sec_on: 'ATTIVA',
    sec_off: 'DISATTIVATA',
    sec_enforcement_active: 'Whitelist IP attiva — solo gli IP elencati accedono al sistema',
    sec_warning: 'Attenzione',
    sec_add_ip_warning: 'aggiungi il tuo IP corrente PRIMA di attivare la whitelist, altrimenti verrai bloccato. Il tuo IP:',
    sec_add_ip: 'Aggiungi IP',
    sec_add: 'Aggiungi',
    sec_your_current_ip: 'Tuo IP attuale',
    sec_max_ips: 'IP nella lista',
    sec_refresh: 'Aggiorna',
    sec_ip_address: 'Indirizzo IP',
    sec_label_optional: 'Etichetta (opzionale)',
    sec_use_current: 'Usa il mio IP',
    sec_ip_list: 'Lista IP autorizzati',
    sec_no_ips: 'Nessun IP autorizzato. Aggiungi il tuo IP corrente per iniziare.',
    sec_this_device: 'questo dispositivo',
    sec_added_by: 'aggiunto da',
    sec_ip_added: 'IP aggiunto',
    sec_ip_deleted: 'IP eliminato',
    sec_ip_required: 'Inserisci un indirizzo IP',
    sec_max_reached: 'Massimo 10 IP raggiunto',
    sec_ip_add_error: 'Errore aggiungendo IP',
    sec_delete_confirm: 'Eliminare l\'IP $ip dalla whitelist?',
    sec_load_error: 'Errore caricando le impostazioni di sicurezza',
    sec_enforce_on: 'Whitelist IP attivata',
    sec_enforce_off: 'Whitelist IP disattivata',
    sec_add_your_ip_first: 'Aggiungi prima il tuo IP alla lista, altrimenti verrai bloccato!',
    sec_my_ip_label: 'Il mio IP',
    // Factory reset
    sec_danger_zone: 'Zona Pericolosa — Reset di Fabbrica',
    sec_reset_desc: 'Cancella tutti i Lead, chiamate, note, richiami, appuntamenti e utenti. Sostituisce le credenziali admin. Operazione irreversibile.',
    sec_reset_start: 'Avvia Reset',
    sec_reset_dialog_title: 'Reset di Fabbrica',
    sec_reset_dialog_desc: 'Prepara il CRM pulito per iniziare a lavorare. Ti farà logout automatico.',
    sec_reset_warning_title: 'Verranno cancellati definitivamente:',
    sec_reset_will_delete_leads: 'Tutti i Lead, chiamate, note, richiami e appuntamenti',
    sec_reset_will_delete_users: 'Tutti gli operatori e admin secondari',
    sec_reset_will_rotate_admin: 'Le credenziali admin verranno sostituite con quelle nuove',
    sec_reset_new_email: 'Nuova email Admin',
    sec_reset_new_password: 'Nuova password Admin',
    sec_reset_new_name: 'Nome completo Admin',
    sec_reset_type_confirm: 'Scrivi per confermare:',
    sec_resetting: 'Reset in corso...',
    sec_reset_confirm_button: 'CANCELLA TUTTO E RESET',
    sec_reset_done: 'Reset completato. Accedi con le nuove credenziali.',
    sec_reset_failed: 'Errore durante il reset',
    // 2FA
    sec_subtitle_2fa: 'Autenticazione a due fattori (2FA) e gestione dati',
    sec_2fa_title: 'Autenticazione a Due Fattori (2FA)',
    sec_2fa_desc: 'Aggiungi un codice a 6 cifre dal tuo smartphone al login. Usa Google Authenticator, Authy, 1Password o qualsiasi app TOTP.',
    sec_2fa_status_on: '✓ 2FA ATTIVA',
    sec_2fa_status_off: '⚠ 2FA NON ATTIVA — l\'account è protetto solo dalla password',
    sec_2fa_enable: 'Attiva 2FA',
    sec_2fa_disable: 'Disattiva 2FA',
    sec_2fa_setup_title: 'Configura 2FA',
    sec_2fa_setup_step1: 'Scansiona il QR con Google Authenticator (o simile), poi inserisci il codice a 6 cifre per confermare.',
    sec_2fa_manual_secret: 'Oppure inserisci manualmente questo codice:',
    sec_2fa_enter_code: 'Codice dall\'app',
    sec_2fa_confirm_enable: 'Attiva',
    sec_2fa_secret_copied: 'Codice copiato',
    sec_2fa_setup_failed: 'Errore avvio configurazione 2FA',
    sec_2fa_enabled_ok: '2FA attivata. Al prossimo login servirà il codice.',
    sec_2fa_disabled_ok: '2FA disattivata',
    sec_2fa_bad_code: 'Codice 2FA non valido',
    sec_2fa_disable_title: 'Disattiva 2FA',
    sec_2fa_disable_desc: 'Per confermare, inserisci la password e un codice 2FA valido.',
    sec_2fa_current_code: 'Codice 2FA attuale',
    sec_2fa_confirm_disable: 'Disattiva',
    login_2fa_title: 'Verifica in 2 passaggi',
    login_2fa_prompt: 'Inserisci il codice a 6 cifre della tua app di autenticazione.',
    login_2fa_code_label: 'Codice',
    login_2fa_button: 'Verifica',
    login_2fa_back: '← Torna alla password',
    login_2fa_bad_code: 'Codice non valido',
    // Call outcomes — Italian canonical values displayed in their canonical form
    outcome_first_deposit: 'Primo Deposito Effettuato',
    outcome_appointment: 'Appuntamento',
    outcome_callback: 'Richiamo',
    outcome_not_interested: 'Non Interessato',
    outcome_no_answer: 'Non Risponde',
    outcome_voicemail: 'Segreteria',
    outcome_wrong_number: 'Numero Errato',
    outcome_non_existent: 'Numero Inesistente',
    outcome_busy: 'Occupato',
    outcome_already_registered: 'Cliente già registrato',
    outcome_undecided: 'Cliente indeciso',
    outcome_needs_info: 'Cliente richiede informazioni',
    outcome_to_recontact: 'Da ricontattare',
    outcome_call_interrupted: 'Chiamata interrotta',
    outcome_not_eligible: 'Cliente non idoneo',
    // Users page family selector
    users_family_label: 'Assegnazione campagne',
    users_family_hint: 'L\'operatore avrà accesso a tutti i lead della famiglia scelta.',
    users_family_english: 'Inglese (English + English Canada)',
    users_family_italian: 'Italiano (Italian)',
    // Users page toasts
    users_required_fields: 'Compila tutti i campi obbligatori',
    users_created_ok: 'Utente creato con successo',
    users_create_error: 'Errore nella creazione dell\'utente',
    users_update_error: 'Errore durante l\'aggiornamento',
    users_delete_confirm: 'Sei sicuro di voler eliminare questo utente?',
    users_deleted_ok: 'Utente eliminato con successo',
    users_delete_error: 'Errore durante l\'eliminazione',
    users_activated_ok: 'Utente attivato con successo',
    users_deactivated_ok: 'Utente disattivato con successo',
    // Campaigns page
    camp_name_required: 'Inserisci un nome per la campagna',
    camp_created_ok: 'Campagna creata con successo',
    camp_create_error: 'Errore nella creazione della campagna',
    camp_update_error: 'Errore durante l\'aggiornamento',
    camp_delete_confirm: 'Sei sicuro di voler eliminare questa campagna?',
    camp_deleted_ok: 'Campagna eliminata con successo',
    camp_delete_error: 'Errore durante l\'eliminazione',
    camp_activated_ok: 'Campagna attivata con successo',
    camp_deactivated_ok: 'Campagna disattivata con successo',
    // Lead detail toasts
    ld_call_registered: 'Chiamata registrata',
    ld_call_error: 'Errore durante il salvataggio',
    ld_call_log_error: 'Errore durante la registrazione della chiamata',
    ld_load_error: 'Errore nel caricamento dei dettagli',
    ld_note_required: 'Inserisci una nota obbligatoria',
    ld_datetime_required: 'Data e ora sono obbligatori',
    ld_appt_created: 'Appuntamento creato',
    ld_appt_error: 'Errore nella creazione dell\'appuntamento',
    ld_cb_created: 'Richiamo programmato',
    ld_cb_error: 'Errore nella programmazione del richiamo',
    ld_number_copied: 'Numero $phone copiato negli appunti',
    ld_select_outcome: 'Seleziona un esito',
    // Password change
    sec_change_password: 'Cambia la mia password',
    sec_change_password_desc: 'Aggiorna la password del tuo account. Serve la password attuale.',
    sec_current_password: 'Password attuale',
    sec_new_password: 'Nuova password',
    sec_confirm_password: 'Conferma nuova password',
    sec_pwd_save: 'Aggiorna password',
    sec_pwd_saving: 'Salvo...',
    sec_pwd_min: 'Minimo 8 caratteri',
    sec_pwd_mismatch: 'Le password non coincidono',
    sec_pwd_changed: 'Password aggiornata',
    sec_pwd_error: 'Errore aggiornamento password',
    // Admin reset user password
    admin_reset_pwd: 'Reset password',
    admin_reset_pwd_title: 'Nuova password per $email',
    admin_reset_pwd_desc: 'Imposta una nuova password (min 8 caratteri). Non serve la password attuale.',
    admin_reset_pwd_placeholder: 'Nuova password',
    admin_reset_pwd_ok: 'Password reimpostata',
    admin_reset_pwd_error: 'Errore reset password',
  },
  en: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    date: 'Date',
    time: 'Time',
    note: 'Note',
    reason: 'Reason',
    back: 'Back',
    close: 'Close',
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    role: 'Role',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    dashboard: 'Dashboard',
    leads: 'Leads',
    campaigns: 'Campaigns',
    calendar: 'Calendar',
    users: 'Users',
    import_leads: 'Import Leads',
    light: 'Light',
    dark: 'Dark',
    login_title: 'CRM Outbound',
    login_subtitle: 'Professional Call Center System',
    login_button: 'Login',
    login_loading: 'Signing in...',
    login_success: 'Login successful',
    login_demo: 'Demo Admin:',
    welcome: 'Welcome',
    total_leads: 'Total Leads',
    new_leads: 'New Leads',
    calls_today: 'Calls Today',
    deposits_today: 'Deposits Today',
    appointments_today: 'Appointments Today',
    callbacks_pending: 'Pending Callbacks',
    conversion_rate: 'Conversion Rate',
    calls_week: 'Weekly Calls',
    calls_deposits: 'Calls and Deposits',
    weekly_performance: 'Weekly Performance',
    leads_title: 'Leads Management',
    leads_total: 'total leads',
    search_placeholder: 'Search by name, phone, email...',
    all_campaigns: 'All campaigns',
    all_status: 'All status',
    all_outcomes: 'All outcomes',
    outcome_none: 'No outcome yet',
    status_new: 'New',
    status_contacted: 'Contacted',
    status_converted: 'Converted',
    no_leads: 'No leads found',
    col_created: 'Creation Date',
    col_name: 'Name',
    col_email: 'Email Address',
    col_origin: 'Origin',
    col_module: 'Module',
    col_channel: 'Channel',
    col_stage: 'Stage',
    col_owner: 'Owner',
    col_labels: 'Labels',
    col_phone: 'Phone',
    col_phone2: 'Secondary Phone',
    col_whatsapp: 'WhatsApp',
    col_notes: 'Notes',
    call_in_progress: 'Call in progress',
    call_outcome: 'Call Outcome',
    call_note: 'Call Note',
    call_save: 'Save Call',
    outcome_required: 'Please select a call outcome',
    note_required: 'Please enter a required note',
    call_saved: 'Call recorded successfully',
    number_copied: 'Number copied to clipboard',
    call: 'Call',
    country: 'Country',
    language: 'Language',
    call_history: 'Call History',
    no_calls: 'No calls recorded',
    operator: 'Operator',
    duration: 'Duration',
    quick_actions: 'Quick Actions',
    create_appointment: 'Create Appointment',
    schedule_callback: 'Schedule Callback',
    fb_notes: 'Facebook Notes',
    no_fb_notes: 'No notes available',
    back_to_leads: 'Back to Leads',
    appointment_created: 'Appointment created successfully',
    callback_created: 'Callback scheduled successfully',
    campaigns_title: 'Campaigns Management',
    campaigns_total: 'total campaigns',
    new_campaign: 'New Campaign',
    campaign_name: 'Campaign Name',
    campaign_created: 'Campaign created successfully',
    campaign_deleted: 'Campaign deleted successfully',
    confirm_delete_campaign: 'Are you sure you want to delete this campaign?',
    users_title: 'Users Management',
    users_total: 'total users',
    new_user: 'New User',
    full_name: 'Full Name',
    campaigns_assigned: 'Assigned Campaigns',
    user_created: 'User created successfully',
    user_deleted: 'User deleted successfully',
    confirm_delete_user: 'Are you sure you want to delete this user?',
    admin: 'Admin',
    operator_role: 'Operator',
    all_campaigns_short: 'All',
    campaigns_count: 'campaigns',
    calendar_title: 'Calendar',
    calendar_subtitle: 'Scheduled appointments and callbacks',
    today: 'Today',
    no_events: 'No events for this day',
    fill_all_fields: 'Please fill all required fields',
    error_generic: 'An error occurred',
    col_outcome: 'Outcome',
    // Import page
    import_title: 'Import Leads',
    import_subtitle: 'Upload a CSV or Excel file and assign to a campaign',
    import_step1: '1. Select Campaign *',
    import_step2: '2. Upload File (CSV / XLSX) *',
    import_choose_campaign: 'Choose English or Italian...',
    import_button: 'Import',
    import_leads_count: 'leads',
    import_importing: 'Importing...',
    import_preview: 'Preview',
    import_preview_rows: 'total rows - first 5 shown',
    import_completed: 'Import completed',
    import_distribution: 'Automatic distribution to operators:',
    import_view_leads: 'Go to Leads',
    import_columns_info: 'Auto-detected columns',
    import_columns_desc: 'Name, Last Name, Phone, Email, Module, Origin, Channel, Stage, Labels, Secondary Phone, WhatsApp, Notes. The first row of the file must contain column names.',
    import_auto_assign_note: 'Leads are automatically distributed among operators assigned to the chosen campaign.',
    // Users management
    users_full_name: 'Full Name *',
    users_email_required: 'Email *',
    users_password_required: 'Password *',
    users_role_required: 'Role *',
    users_campaign_label: 'Assigned Campaign (only one)',
    users_create_new_title: 'Create New User',
    users_create_new_desc: 'Enter the details of the new user',
    users_submit: 'Create User',
    // Campaigns
    campaigns_active: 'Active',
    campaigns_inactive: 'Inactive',
    campaigns_created_on: 'Created on',
    campaigns_create_title: 'Create New Campaign',
    campaigns_create_desc: 'Enter the name of the new campaign',
    campaigns_submit: 'Create Campaign',
    // Motivational
    motivational_title: '💎 Every call is a new opportunity',
    motivational_sub: 'Turn leads into successes',
    // Lead detail
    ld_back: 'Back to Leads',
    ld_number_to_call: 'Number to call',
    ld_copy_number: 'Copy Number',
    ld_copied: 'Copied!',
    ld_register_call: 'Record Call Outcome',
    ld_outcome_label: 'Outcome *',
    ld_note_label: 'Note *',
    ld_outcome_placeholder: 'Select outcome...',
    ld_note_placeholder: 'Enter call details...',
    ld_save_call: 'Save Call',
    ld_saving: 'Saving...',
    ld_outcome_hint: 'Choosing "Appuntamento" or "Richiamo" opens the scheduling form immediately.',
    ld_appointments: 'Appointments',
    ld_callbacks: 'Callbacks',
    ld_new: 'New',
    ld_no_appointments: 'No appointments',
    ld_no_callbacks: 'No callbacks',
    ld_call_history: 'Call History',
    ld_no_calls: 'No calls recorded',
    ld_new_appointment: 'New Appointment',
    ld_new_callback: 'New Callback',
    ld_reason: 'Reason',
    ld_create_appointment: 'Create Appointment',
    ld_schedule_callback: 'Schedule Callback',
    ld_fb_notes: 'Facebook Notes',
    ld_pick_date: 'Pick a date',
    ld_pick_time: 'Pick a time',
    // Notifications
    notif_callback_title: '⏰ Callback in 10 minutes',
    notif_open_lead: 'Open Lead',
    // Export
    export: 'Export',
    export_csv: 'CSV',
    export_xlsx: 'Excel',
    export_pdf: 'PDF',
    export_started: 'Exporting...',
    export_completed: 'Export completed',
    export_failed: 'Export failed',
    // Export dialog filters
    export_dialog_title: 'Export Leads',
    export_dialog_desc: 'Choose format and filters before downloading',
    export_format: 'Format',
    export_filter_operator: 'Operator',
    export_filter_campaign: 'Campaign',
    export_filter_all_operators: 'All operators',
    export_filter_all_campaigns: 'All campaigns',
    export_download: 'Download',
    // Bulk reassign
    bulk_selected: 'leads selected',
    bulk_reassign_button: 'Reassign',
    bulk_reassign_title: 'Reassign selected leads',
    bulk_reassign_desc: 'Choose the operator to whom the selected leads will be assigned.',
    bulk_reassign_operator_label: 'New operator',
    bulk_reassign_operator_placeholder: 'Select an operator',
    bulk_reassign_confirm: 'Confirm reassignment',
    bulk_reassign_cancel: 'Cancel',
    bulk_reassign_success: 'Reassigned $count leads to $name',
    bulk_reassign_error: 'Reassignment error',
    bulk_reassign_pick_operator: 'Please pick an operator',
    bulk_clear: 'Clear',
    // Users - edit campaigns
    users_edit_campaigns_title: 'Edit campaigns',
    users_edit_campaigns_desc: 'Select one or more campaigns. The operator will only see leads for the selected campaigns.',
    users_edit_campaigns_ok: 'Campaigns updated',
    users_edit_campaigns_min: 'Select at least one campaign',
    users_edit_saving: 'Saving...',
    users_edit_save: 'Save',
    users_all_campaigns: 'All',
    // Calendar list view
    view_calendar: 'Calendar',
    view_list: 'List',
    list_appointments_title: 'Clients with Appointment',
    list_callbacks_title: 'Clients to Call Back',
    list_all_title: 'Clients List',
    list_subtitle: 'Complete list with name, phone and notes',
    list_filter_all: 'All',
    list_filter_appointments: 'Appointments',
    list_filter_callbacks: 'Callbacks',
    list_col_datetime: 'Date & time',
    list_empty: 'No clients with this outcome.',
    open_lead: 'Open Lead',
    // Security page
    sec_nav: 'Security',
    sec_title: 'Security',
    sec_subtitle: 'IP Whitelist: only IPs listed here can access the system',
    sec_enforce_title: 'IP Restriction',
    sec_enforce_desc: 'Enable to block access from any IP not in the list. Maximum 10 IPs.',
    sec_on: 'ON',
    sec_off: 'OFF',
    sec_enforcement_active: 'IP whitelist active — only listed IPs can access the system',
    sec_warning: 'Warning',
    sec_add_ip_warning: 'add your current IP BEFORE enabling the whitelist, otherwise you\'ll be locked out. Your IP:',
    sec_add_ip: 'Add IP',
    sec_add: 'Add',
    sec_your_current_ip: 'Your current IP',
    sec_max_ips: 'IPs in list',
    sec_refresh: 'Refresh',
    sec_ip_address: 'IP Address',
    sec_label_optional: 'Label (optional)',
    sec_use_current: 'Use my IP',
    sec_ip_list: 'Authorized IPs',
    sec_no_ips: 'No authorized IPs. Add your current IP to get started.',
    sec_this_device: 'this device',
    sec_added_by: 'added by',
    sec_ip_added: 'IP added',
    sec_ip_deleted: 'IP deleted',
    sec_ip_required: 'Please enter an IP address',
    sec_max_reached: 'Maximum 10 IPs reached',
    sec_ip_add_error: 'Error adding IP',
    sec_delete_confirm: 'Delete IP $ip from the whitelist?',
    sec_load_error: 'Error loading security settings',
    sec_enforce_on: 'IP whitelist enabled',
    sec_enforce_off: 'IP whitelist disabled',
    sec_add_your_ip_first: 'Add your IP to the list first, otherwise you\'ll be locked out!',
    sec_my_ip_label: 'My IP',
    // Factory reset
    sec_danger_zone: 'Danger Zone — Factory Reset',
    sec_reset_desc: 'Deletes all leads, calls, notes, callbacks, appointments and users. Replaces admin credentials. This is irreversible.',
    sec_reset_start: 'Start Reset',
    sec_reset_dialog_title: 'Factory Reset',
    sec_reset_dialog_desc: 'Prepare a clean CRM ready to start working. You will be logged out.',
    sec_reset_warning_title: 'Will be permanently deleted:',
    sec_reset_will_delete_leads: 'All leads, calls, notes, callbacks and appointments',
    sec_reset_will_delete_users: 'All operators and secondary admins',
    sec_reset_will_rotate_admin: 'Admin credentials will be replaced with the new ones',
    sec_reset_new_email: 'New Admin email',
    sec_reset_new_password: 'New Admin password',
    sec_reset_new_name: 'New Admin full name',
    sec_reset_type_confirm: 'Type to confirm:',
    sec_resetting: 'Resetting...',
    sec_reset_confirm_button: 'DELETE ALL AND RESET',
    sec_reset_done: 'Reset completed. Log in with the new credentials.',
    sec_reset_failed: 'Reset failed',
    // 2FA
    sec_subtitle_2fa: 'Two-factor authentication (2FA) and data management',
    sec_2fa_title: 'Two-Factor Authentication (2FA)',
    sec_2fa_desc: 'Add a 6-digit code from your smartphone at login. Compatible with Google Authenticator, Authy, 1Password or any TOTP app.',
    sec_2fa_status_on: '✓ 2FA ENABLED',
    sec_2fa_status_off: '⚠ 2FA NOT ENABLED — account protected by password only',
    sec_2fa_enable: 'Enable 2FA',
    sec_2fa_disable: 'Disable 2FA',
    sec_2fa_setup_title: 'Set up 2FA',
    sec_2fa_setup_step1: 'Scan the QR with Google Authenticator (or similar), then enter the 6-digit code to confirm.',
    sec_2fa_manual_secret: 'Or enter this secret manually:',
    sec_2fa_enter_code: 'Code from the app',
    sec_2fa_confirm_enable: 'Enable',
    sec_2fa_secret_copied: 'Secret copied',
    sec_2fa_setup_failed: '2FA setup failed',
    sec_2fa_enabled_ok: '2FA enabled. You will need the code at next login.',
    sec_2fa_disabled_ok: '2FA disabled',
    sec_2fa_bad_code: 'Invalid 2FA code',
    sec_2fa_disable_title: 'Disable 2FA',
    sec_2fa_disable_desc: 'To confirm, enter your password and a valid 2FA code.',
    sec_2fa_current_code: 'Current 2FA code',
    sec_2fa_confirm_disable: 'Disable',
    login_2fa_title: '2-step verification',
    login_2fa_prompt: 'Enter the 6-digit code from your authenticator app.',
    login_2fa_code_label: 'Code',
    login_2fa_button: 'Verify',
    login_2fa_back: '← Back to password',
    login_2fa_bad_code: 'Invalid code',
    // Password change
    sec_change_password: 'Change my password',
    sec_change_password_desc: 'Update your account password. Requires the current password.',
    sec_current_password: 'Current password',
    sec_new_password: 'New password',
    sec_confirm_password: 'Confirm new password',
    sec_pwd_save: 'Update password',
    sec_pwd_saving: 'Saving...',
    sec_pwd_min: 'Minimum 8 characters',
    sec_pwd_mismatch: 'Passwords do not match',
    sec_pwd_changed: 'Password updated',
    sec_pwd_error: 'Password update failed',
    // Admin reset user password
    admin_reset_pwd: 'Reset password',
    admin_reset_pwd_title: 'New password for $email',
    admin_reset_pwd_desc: 'Set a new password (min 8 characters). Current password is not required.',
    admin_reset_pwd_placeholder: 'New password',
    admin_reset_pwd_ok: 'Password reset',
    admin_reset_pwd_error: 'Password reset failed',
    // Call outcomes
    outcome_first_deposit: 'First Deposit Made',
    outcome_appointment: 'Appointment',
    outcome_callback: 'Callback',
    outcome_not_interested: 'Not Interested',
    outcome_no_answer: 'No Answer',
    outcome_voicemail: 'Voicemail',
    outcome_wrong_number: 'Wrong Number',
    outcome_non_existent: 'Non-existent Number',
    outcome_busy: 'Busy',
    outcome_already_registered: 'Client already registered',
    outcome_undecided: 'Client undecided',
    outcome_needs_info: 'Client needs information',
    outcome_to_recontact: 'To recontact',
    outcome_call_interrupted: 'Call interrupted',
    outcome_not_eligible: 'Client not eligible',
    // Users page family selector
    users_family_label: 'Campaign assignment',
    users_family_hint: 'The operator will have access to all leads of the selected family.',
    users_family_english: 'English (English + English Canada)',
    users_family_italian: 'Italian (Italian)',
    // Users page toasts
    users_required_fields: 'Fill in all required fields',
    users_created_ok: 'User created successfully',
    users_create_error: 'Error creating user',
    users_update_error: 'Error during update',
    users_delete_confirm: 'Are you sure you want to delete this user?',
    users_deleted_ok: 'User deleted successfully',
    users_delete_error: 'Error during deletion',
    users_activated_ok: 'User activated successfully',
    users_deactivated_ok: 'User deactivated successfully',
    // Campaigns page
    camp_name_required: 'Please enter a campaign name',
    camp_created_ok: 'Campaign created successfully',
    camp_create_error: 'Error creating campaign',
    camp_update_error: 'Error during update',
    camp_delete_confirm: 'Are you sure you want to delete this campaign?',
    camp_deleted_ok: 'Campaign deleted successfully',
    camp_delete_error: 'Error during deletion',
    camp_activated_ok: 'Campaign activated successfully',
    camp_deactivated_ok: 'Campaign deactivated successfully',
    // Lead detail toasts
    ld_call_registered: 'Call registered',
    ld_call_error: 'Error while saving',
    ld_call_log_error: 'Error while logging call',
    ld_load_error: 'Error loading details',
    ld_note_required: 'Please enter a required note',
    ld_datetime_required: 'Date and time are required',
    ld_appt_created: 'Appointment created',
    ld_appt_error: 'Error creating appointment',
    ld_cb_created: 'Callback scheduled',
    ld_cb_error: 'Error scheduling callback',
    ld_number_copied: 'Number $phone copied to clipboard',
    ld_select_outcome: 'Please select an outcome',
  },
};
